import { corporateCMSApi } from "~/Services";
import { decodeHTML } from "~/Utils/CommonUtils";
import { ModuleFields } from "~/Utils/drilldownData";

// Define the option type for select fields
export interface OptionType {
  label: string;
  value: string;
}

// Create a type for fields that may have async options
export type AsyncSelectField = ModuleFields & {
  loadOptions?: () => Promise<OptionType[]>;
};

// Function to fetch data and transform to options
const fetchDataAndTransform = async (url: string): Promise<OptionType[]> => {
  try {
    const res = await corporateCMSApi.get(`${url}`);
    if (res?.data) {
      return res.data
        .filter((item: any) => item.published === true)
        .map((item: any) => ({
          label: decodeHTML(item.name),
          value: item.name,
        }));
    }
    return [];
  } catch (err) {
    console.error("Error fetching data:", err);
    return [];
  }
};

export const fetchParentData = () => fetchDataAndTransform("/api/get-footer-main-menu/all-fields");

export const fetchChildData = () => fetchDataAndTransform("/api/get-footer-child-menu/all-fields");
